import { Row, Typography } from "antd";
import LinearGauge, { LinearGaugeType } from "./LinearGauge";
import { useMemo } from "react";
import { formatNumber } from "src/utils/formatting";
import React from "react";

const { Text } = Typography; 

export interface MoistureGaugeProps {
    moisture: number | null | undefined;
    label: string;
}

const MoistureGauge : React.FC<MoistureGaugeProps> = ({ moisture, label}) => {

    const moistureScaleData = useMemo( () => {
        return [0, 2.5, 5, 7.5, 10, 12.5, 15, 17.5, 20, 22.5, 25, 27.5, 30]}, []);

    return(
        <div>
            <div className="custom-gauge-header">
                <Text style={{ fontFamily:'monospace', fontWeight: "bold"}}>{label}: {formatNumber(moisture, { decimalPlaces: 1, suffix: "%"})}</Text>
            </div>
            <div className="custom-gauge-div">
                <LinearGauge 
                currentValue={moisture} 
                scaleData={moistureScaleData} 
                colorCodedGaugeExists={false}
                type={LinearGaugeType.HumidityOrMoisture}
                needleAnimationSpeed={0.05}
                />
            </div>
        </div>

    )
}

export default MoistureGauge;